module.exports = __webpack_public_path__ + "static/media/total-complete.660c70e4.svg";